module.exports = __webpack_public_path__ + "static/img/13.ca64167.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/4/zh/13.png
// module id = ZqdR
// module chunks = 0